export default {
	dashboard: {
		sections: {
			pulse: 'Live-Überblick',
			activity: 'Aktivitäten & Kommentare',
			workspace: 'Arbeitsbereich',
			operations: 'Vorgänge',
		},
		kpi: {
			reports: 'Meldungen',
			tasks: 'Wiedervorlagen',
			craftsmanTasks: 'Handwerkeraufträge',
			reviewDocuments: 'Belegprüfungen',
			personUpdates: 'Datenänderungen',
			meters: 'Zählerstände',
			overdueCaption: 'überfällig',
			openCaption: 'offen',
			soonBadge: '{count} in den nächsten 7 Tagen',
			staleBadge: '{count} seit über 7 Tagen offen',
			onTrack: 'Im Zeitplan',
			allCurrent: 'Alle aktuell',
			noneOpen: 'Nichts offen',
			totalTooltip: '{count} insgesamt',
			countTooltip: '{loaded} geladen / {total} insgesamt',
			showAll: 'Alle anzeigen',
			allReports: 'Alle Meldungen',
			allTasks: 'Alle Wiedervorlagen',
			allCraftsmanTasks: 'Alle Aufträge',
			filterOpen: 'Offen',
			filterAll: 'Alle',
			filterBuilding: 'Objekt',
			filterType: 'Meldetyp',
			filterStatus: 'Status',
			emptyTasks: 'Keine Wiedervorlagen vorhanden.',
			emptyCraftsmanTasks: 'Keine offenen Handwerkeraufträge.',
			emptyReports: 'Keine Meldungen vorhanden.',
			reportFallback: 'Meldung',
			internal: 'Interne Meldung',
		},
		documents: {
			title: 'Neue Dokumente',
			updatedSinceLastLogin:
				'Diese Dokumente wurden seit Ihrer letzten {lastLogin} aktualisiert.',
			empty: 'Keine neuen Dokumente seit dem letzten Login.',
			countTooltip: 'Neue Dokumente seit dem letzten Login',
		},
		buildings: {
			myObjects: 'Meine Objekte',
			title: 'Objekte',
			empty: 'Keine Objekte vorhanden.',
			units: '{count} Einheit | {count} Einheiten',
		},
		notifications: {
			title: 'Benachrichtigungen',
			empty: 'Keine ungelesenen Benachrichtigungen.',
			emptyAll: 'Keine Benachrichtigungen vorhanden.',
			markAllRead: 'Alle als gelesen markieren',
			countTooltip: 'Ungelesen / insgesamt',
			filterUnread: 'Ungelesen',
			filterAll: 'Alle',
			unread: 'Ungelesen',
			digestCount: '{count} neuer Kommentar | {count} neue Kommentare',
		},
		activityFeed: {
			title: 'Aktivitäten',
			empty: 'Keine Aktivitäten vorhanden.',
			created: 'erstellt',
			updated: 'geändert',
			deleted: 'gelöscht',
			countTooltip: 'Ungelesene Änderungen',
			erpSync: 'ERP-Sync',
			detail: {
				action: 'Aktion',
				by: 'Von',
				at: 'Am',
			},
		},
		models: {
			'App\\Model\\Building': 'Gebäude',
			'App\\Model\\Persons': 'Person',
			'App\\Model\\Unit': 'Einheit',
			'App\\Model\\Document': 'Dokument',
			'App\\Model\\Notes': 'Notiz',
			'App\\Model\\Tasks\\Task': 'Wiedervorlage',
			'App\\Model\\CraftsmanTask': 'Handwerkerauftrag',
			'App\\Model\\Reports\\Report': 'Meldung',
			'App\\Model\\Cis': 'Anlage',
			'App\\Model\\Cis\\Cis': 'Anlage',
			'App\\Model\\Roles': 'Rolle',
			'App\\Model\\Team': 'Team',
			'App\\Model\\Invoices': 'Rechnung',
			'App\\Model\\Accounts\\Accounts': 'Konto',
			'App\\Model\\Accounts\\Journals': 'Buchung',
			'App\\Model\\ReviewDocuments\\ReviewDocuments': 'Belegprüfung',
		},
		comments: {
			title: 'Kommentare',
			empty: 'Keine Kommentare vorhanden.',
			markAllRead: 'Alle als gelesen markieren',
			filterAll: 'Alle',
			filterUnread: 'Ungelesen',
			emptyUnread: 'Keine ungelesenen Kommentare.',
			context: {
				report: 'Meldung',
				account: 'Konto',
				journal: 'Buchung',
				reviewDocument: 'Belegprüfung',
				email: 'E-Mail',
			},
		},
		commentDialog: {
			title: 'Kommentar',
			journalDetails: 'Buchungsdetails',
			bookingText: 'Buchungstext',
			bookingDate: 'Buchungsdatum',
			debit: 'Soll',
			credit: 'Haben',
			primanota: 'Primanota',
			accountRef: 'Konto-Ref.',
			accountDetails: 'Kontodetails',
			accountNo: 'Konto-Nr.',
			designation: 'Bezeichnung',
			buildingRef: 'Gebäude-Ref.',
			edited: 'bearbeitet {time}',
			edit: 'Bearbeiten',
			delete: 'Löschen',
			save: 'Speichern',
			cancel: 'Abbrechen',
			report: 'Meldung',
			internal: 'Intern',
			readBy: 'Gelesen von {count} Person | Gelesen von {count} Personen',
			replies: '{count} Antwort | {count} Antworten',
			reply: 'Antworten',
			replyPlaceholder: 'Antwort schreiben …',
			contextReviewDocument: 'Belegprüfung: {name}',
			contextAccount: 'Konto: {name}',
			contextJournal: 'Buchung: {name}',
			contextReport: 'Meldung #{id}',
			contextEmail: 'E-Mail',
		},
		syncs: {
			title: 'Synchronisierung',
			empty: 'Keine Synchronisierungen vorhanden.',
			lastSync: 'Letzte Synchronisierung',
			statusDone: 'Abgeschlossen',
			statusRunning: 'Läuft …',
			changes: '{count} Änderung | {count} Änderungen',
			noDetails: 'Keine Details verfügbar',
			showDetails: 'Details anzeigen',
			open: 'Synchronisierung öffnen',
			allLoaded: 'Alle {count} Einträge geladen',
			runningFor: 'seit {duration}',
			duration: {
				seconds: '{s} Sek.',
				minutes: '{m} Min. {s} Sek.',
				hours: '{h} Std. {m} Min.',
				days: '{d} Tg. {h} Std.',
			},
			models: {
				'App\\Model\\Building': 'Gebäude',
				'App\\Model\\Persons': 'Personen',
				'App\\Model\\Unit': 'Einheiten',
				'App\\Model\\Document': 'Dokumente',
				'App\\Model\\Notes': 'Notizen',
				'App\\Model\\Tasks\\Task': 'Wiedervorlagen',
				'App\\Model\\CraftsmanTask': 'Handwerkeraufträge',
				'App\\Model\\Reports\\Report': 'Meldungen',
				'App\\Model\\Cis': 'Anlagen',
				'App\\Model\\Accounts\\Accounts': 'Konten',
				'App\\Model\\Accounts\\Journals': 'Buchungen',
				'App\\Model\\Invoices': 'Rechnungen',
				'App\\Model\\MeterLevelDetection\\MeterLevel': 'Zählerstände',
			},
		},
		tasks: {
			title: 'Wiedervorlagen',
			empty: 'Keine offenen Wiedervorlagen.',
			countTooltip: 'Fällige Wiedervorlagen',
		},
		notes: {
			title: 'Notizen',
			empty: 'Keine Notizen vorhanden.',
			create: 'Notiz anlegen',
			filterActive: 'Aktive',
			filterAll: 'Alle',
			filterBuilding: 'Objekt',
			filterType: 'Typ',
			layoutList: 'Listenansicht',
			layoutGrid: 'Kachelansicht',
			priorityHigh: 'Hohe Priorität',
			priorityMedium: 'Mittlere Priorität',
			comments: '{count} Kommentar | {count} Kommentare',
			buildingsCount: '{count} Objekt | {count} Objekte',
			rolesCount: '{count} Rolle | {count} Rollen',
			documentsCount: '{count} Dokument | {count} Dokumente',
			document: 'Dokument',
			readMore: 'Mehr lesen',
		},
		cis: {
			title: 'ZIS',
			empty: 'Keine ZIS-Einträge vorhanden.',
			system: 'Anlage',
			statusDone: 'Erledigt',
			statusOpen: 'Offen',
		},
		reviewDocuments: {
			title: 'Belegprüfung',
			empty: 'Keine Belegprüfungen vorhanden.',
			filterOpen: 'Offen',
			filterDone: 'Abgeschlossen',
			filterAll: 'Alle',
			countTooltip: 'Offene Belegprüfungen',
			statusDone: 'Abgeschlossen',
			statusOpen: 'Offen',
			mine: 'Ihre offenen Belegprüfungen',
			progress: 'Fortschritt: {percent} %',
			reviewersOpen: '{open}/{total} Prüfer offen',
			unreadComments: 'Ungelesene Kommentare: {count}',
			lastReview: 'Letzte Prüfung',
			reviewer: {
				finished: 'Abgeschlossen',
				rejected: 'Abgelehnt',
				pending: 'Ausstehend',
				unknown: 'Unbekannt',
			},
		},
		craftsmanTasks: {
			title: 'Handwerkeraufträge',
			empty: 'Keine offenen Aufträge.',
			countTooltip: 'Offene Aufträge',
			deadline: 'Frist',
			noDeadline: 'Ohne Frist',
			plannedFor: 'geplant {date}',
		},
		todo: {
			title: 'Zu erledigen',
			empty: 'Nichts fällig.',
			countTooltip:
				'Überfällig oder in den nächsten 7 Tagen fällig, davon {overdue} überfällig',
			shownOfTotal:
				'{shown} von {total} angezeigt. Weitere finden Sie in den jeweiligen Bereichen.',
		},
		search: {
			placeholder: 'Objekte, Personen, Meldungen suchen…',
			noResults: 'Keine Treffer für „{query}“.',
			moreResults: 'Weitere Treffer',
			searching: 'Suche läuft …',
			indexing: 'Wird indiziert…',
			shortcut: 'Taste / fokussiert die Suche',
			fallback: {
				notification: 'Benachrichtigung',
				comment: 'Kommentar',
				note: 'Notiz',
				building: 'Gebäude',
				document: 'Dokument',
				sync: 'Sync #{id}',
			},
		},
		presets: {
			standard: {
				name: 'Standard',
				desc: 'Die bisherige Aufteilung mit vier Bereichen.',
			},
			daily: {
				name: 'Tagesgeschäft',
				desc: 'Eingänge zuerst: Benachrichtigungen, Kommentare, Objekte.',
			},
			billing: {
				name: 'Abrechnung',
				desc: 'Belegprüfung, Dokumente und Synchronisierung im Fokus.',
			},
			overview: {
				name: 'Übersicht',
				desc: 'Alles auf einen Blick, kompakt in drei Spalten.',
			},
			minimal: {
				name: 'Basis',
				desc: 'Handlungsbedarf zuerst: Zu erledigen, Notizen, Kommentare, Belegprüfung, Benachrichtigungen, Dokumente, Objekte.',
			},
		},
		edit: {
			title: 'Layout bearbeiten',
			start: 'Layout bearbeiten',
			choosePreset: 'Vorlage wählen…',
			ownLayout: 'Eigenes Layout',
			ownDesc: '{n} Widgets · eigenes Layout',
			selected: 'Ausgewählt',
			deselect: 'Auswahl aufheben (Esc)',
			headerText: 'Text',
			width: 'Breite',
			widthOf: '{w} von 12 Spalten',
			full: 'Voll',
			rows: 'Zeilen in der Liste',
			rowsLess: 'Eine Zeile weniger',
			rowsMore: 'Eine Zeile mehr',
			density: 'Dichte',
			density_normal: 'Normal',
			density_compact: 'Kompakt',
			position: 'Position',
			left: 'Nach links (←)',
			up: 'Nach oben (↑)',
			down: 'Nach unten (↓)',
			right: 'Nach rechts (→)',
			moveUp: 'Nach oben',
			moveDown: 'Nach unten',
			remove: 'Vom Dashboard entfernen',
			tabBlocks: 'Bausteine',
			tabKpi: 'Kennzahlen',
			tabPresets: 'Vorlagen',
			placed: 'Auf dem Dashboard · {n}',
			available: 'Verfügbar',
			allPlaced: 'Alle Widgets sind platziert.',
			add: 'Hinzufügen',
			header: 'Überschrift',
			headerItem: 'Überschrift · {label}',
			newSection: 'Neuer Bereich',
			greeting: 'Begrüßung',
			greetingShow: 'Begrüßungstext anzeigen',
			kpiHint: 'Reihenfolge und Sichtbarkeit der Kennzahlen oben.',
			hidden: 'Ausgeblendet',
			presetHint:
				'Eine Vorlage ersetzt das aktuelle Layout. Mit Strg+Z lässt sich das rückgängig machen.',
			active: 'Aktiv',
			deletePreset: 'Layout löschen',
			saveTitle: 'Aktuelles Layout speichern',
			savePlaceholder: 'Name, z. B. Montagsrunde',
			save: 'Speichern',
			refreshTitle: 'Automatische Aktualisierung',
			dragWidth: 'Breite ziehen',
			dragRows: 'Zeilen ziehen',
			dragSize: 'Größe ziehen',
			sizeTag: '{w}/12',
			sizeTagRows: '{w}/12 · {rows} Zeilen',
			undo: 'Rückgängig (Strg+Z)',
			redo: 'Wiederholen (Strg+⇧+Z)',
			cancel: 'Abbrechen',
			done: 'Fertig',
			hintIdle: 'Widget anklicken oder an der Kopfzeile ziehen',
			hintSelected: '←→↑↓ verschieben · ⇧ Größe · Entf entfernen',
			hintMobile: 'Pfeile ändern die Reihenfolge',
			saveFailed:
				'Das Layout konnte nicht gespeichert werden. Bitte versuchen Sie es erneut oder brechen Sie die Bearbeitung ab.',
			refreshMinutes: '{n} Min.',
			deletePresetConfirm: 'Das Layout „{name}“ löschen?',
		},
		settings: {
			customize: 'Anpassen',
			resetMenu: 'Auf Basis zurücksetzen',
			reset: 'Zurücksetzen',
			resetConfirm:
				'Dashboard auf die Vorlage „Basis“ zurücksetzen? Ihre gespeicherten eigenen Layouts bleiben erhalten.',
			resetTitle: 'Basis-Layout wiederherstellen',
			loadFailed: 'Ihr Dashboard-Layout konnte nicht geladen werden.',
			retry: 'Erneut versuchen',
		},
		freshness: {
			justUpdated: 'Gerade aktualisiert',
			minutesAgo: 'Vor {min} Min. aktualisiert',
			hoursAgo: 'Vor {hours} Std. aktualisiert',
			updating: 'Aktualisiere...',
			refresh: 'Daten aktualisieren',
		},
		common: {
			due: {
				today: 'heute',
				tomorrow: 'morgen',
				yesterday: 'gestern',
				inDays: 'in {n} Tagen',
				daysAgo: 'vor {n} Tagen',
			},
			new: 'Neu',
			showAll: 'Alle anzeigen',
			fullscreen: 'Vollbild',
			exitFullscreen: 'Vollbild beenden',
			expand: 'Widget erweitern',
			collapse: 'Widget minimieren',
			hide: 'Widget ausblenden',
			loadingMore: 'Weitere werden geladen …',
			endOfList: 'Ende der Liste',
			loadError: 'Die Daten konnten nicht geladen werden.',
			retry: 'Erneut laden',
			close: 'Schließen',
			unknown: 'Unbekannt',
			unavailable: 'Objekt nicht mehr verfügbar',
		},
		tour: {
			open: 'Dashboard-Tour starten',
			shared: {
				search: {
					title: 'Suche',
					text: 'Durchsucht die Einträge Ihrer Widgets und darunter weitere Objekte, Personen und Meldungen. Mit der Taste <kbd>/</kbd> springen Sie direkt hinein, ein Treffer öffnet den Eintrag.',
					// Unter 960 px (schmal und mittel): ohne Tastenkürzel
					text_compact:
						'Durchsucht die Einträge Ihrer Widgets und darunter weitere Objekte, Personen und Meldungen. Tippen Sie einen Begriff ein, ein Treffer öffnet den Eintrag.',
				},
				greeting: {
					title: 'Begrüßung',
					text: 'Hier steht der Begrüßungstext des Portals. Beim Bearbeiten des Layouts können Sie ihn für sich ausblenden.',
					text_compact:
						'Hier steht der Begrüßungstext des Portals. Ausblenden können Sie ihn beim Bearbeiten des Layouts auf einem breiteren Bildschirm.',
				},
				widget: {
					title: 'Widgets',
					text: 'Jedes Widget zeigt einen Ausschnitt Ihrer Daten, die Zahl im Kopf nennt offene oder neue Einträge. Rechts im Kopf vergrößern Sie ein Widget auf die volle Breite oder blenden es aus. Ausgeblendete Widgets holen Sie beim Bearbeiten des Layouts zurück.',
					text_compact:
						'Jedes Widget zeigt einen Ausschnitt Ihrer Daten, die Zahl im Kopf nennt offene oder neue Einträge. Rechts im Kopf vergrößern Sie ein Widget oder blenden es aus. Ausgeblendete Widgets holen Sie beim Bearbeiten des Layouts auf einem breiteren Bildschirm zurück.',
				},
				section: {
					title: 'Bereiche',
					text: 'Überschriften gliedern das Dashboard. Ein Klick auf eine Überschrift klappt den Bereich darunter zu oder wieder auf, das bleibt für Sie gespeichert.',
				},
				todo: {
					title: 'Zu erledigen',
					text: 'Sammelt aus allen für Sie freigegebenen Bereichen, was überfällig ist oder in den nächsten sieben Tagen fällig wird.',
				},
				notifications: {
					title: 'Benachrichtigungen',
					text: 'Neue Dokumente, Notizen, Kommentare und Statusänderungen erscheinen hier. Ungelesene sind hervorgehoben, über den Knopf im Kopf markieren Sie alle als gelesen.',
				},
				comments: {
					title: 'Kommentare',
					text: 'Die neuesten Kommentare, zum Beispiel zu Meldungen oder Belegprüfungen. Ein Klick öffnet den Kommentar mit seinem Zusammenhang, dort können Sie direkt antworten.',
				},
				refresh: {
					title: 'Aktualität',
					text: 'Daneben sehen Sie, wie aktuell die angezeigten Daten sind. Mit diesem Knopf laden Sie sie sofort neu.',
					text_compact:
						'Mit diesem Knopf laden Sie die angezeigten Daten sofort neu.',
				},
				settings: {
					title: 'Anpassen',
					text: 'Hier passen Sie das Dashboard an: Layout bearbeiten, eine Vorlage wählen oder auf das Basis-Layout zurücksetzen. Auch diese Tour starten Sie hier jederzeit erneut.',
					text_compact:
						'Über dieses Symbol passen Sie das Dashboard an: die Reihenfolge der Widgets ändern oder auf das Basis-Layout zurücksetzen. Auch diese Tour starten Sie hier jederzeit erneut.',
				},
				edit_grid: {
					title: 'Layout bearbeiten',
					text: 'Im Bearbeiten-Modus ordnen Sie die Widgets frei an: an der Kopfzeile ziehen, an den Rändern Breite und Zeilen ändern. Ein angeklicktes Widget verschieben Sie auch mit den Pfeiltasten. Für diese Tour ist der Modus nur geöffnet, verändert wird nichts.',
					title_compact: 'Reihenfolge ändern',
					text_compact:
						'Im Bearbeiten-Modus ändern Sie die Reihenfolge: Die Pfeile im Kopf eines Widgets oder einer Überschrift schieben es nach oben oder unten. Diese Reihenfolge gilt nur für schmale Bildschirme, das Layout auf breiten Bildschirmen bleibt, wie es ist. Für diese Tour ist der Modus nur geöffnet, verändert wird nichts.',
				},
				edit_more_on_wide: {
					title: 'Mehr auf breiteren Bildschirmen',
					text: 'Auf einem breiteren Bildschirm, zum Beispiel am Computer, können Sie beim Bearbeiten außerdem Widgets und Überschriften hinzufügen, ausgeblendete Widgets zurückholen, Kennzahlen anordnen, Vorlagen wählen und die Größe der Widgets ändern.',
				},
				edit_blocks: {
					title: 'Bausteine',
					text: 'Hier sehen Sie, was auf dem Dashboard liegt und was noch verfügbar ist. Sie fügen Widgets und Überschriften hinzu und blenden die Begrüßung ein oder aus. Welche Widgets verfügbar sind, richtet sich nach Ihren Freigaben.',
				},
				edit_kpi: {
					title: 'Kennzahlen anordnen',
					text: 'Legen Sie fest, welche Kennzahlen oben erscheinen und in welcher Reihenfolge.',
				},
				edit_presets: {
					title: 'Vorlagen',
					text: 'Eine Vorlage ersetzt das aktuelle Layout mit einem Klick, mit Strg+Z machen Sie das rückgängig. Darunter speichern Sie Ihr eigenes Layout unter einem Namen und legen fest, wie oft sich das Dashboard automatisch aktualisiert.',
				},
				edit_dock: {
					title: 'Speichern oder verwerfen',
					text: 'Diese Leiste bleibt beim Bearbeiten sichtbar: Rückgängig und Wiederholen, „Abbrechen“ verwirft alle Änderungen, „Fertig“ speichert das Layout. Die Tour schließt die Bearbeitung gleich wieder, ohne zu speichern.',
				},
				outro: {
					title: 'Alles im Blick',
					text: 'Diese Tour finden Sie jederzeit unter <strong>Anpassen → Dashboard-Tour starten</strong>.',
					text_compact:
						'Diese Tour starten Sie jederzeit erneut über diesen Knopf und <strong>Dashboard-Tour starten</strong>.',
				},
			},
			team: {
				welcome: {
					title: 'Ihr Dashboard',
					text: 'Das Dashboard bündelt, was heute ansteht: Kennzahlen, fällige Vorgänge, neue Kommentare und den Stand der Synchronisierung. In wenigen Schritten zeigen wir Ihnen, wie Sie es lesen und an Ihre Arbeitsweise anpassen. Beenden können Sie die Tour jederzeit über das ✕ oder <kbd>Esc</kbd>.',
				},
				kpi: {
					title: 'Kennzahlen',
					text: 'Die Leiste zeigt offene und überfällige Vorgänge, etwa Meldungen, Wiedervorlagen, Handwerkeraufträge oder Datenänderungen. Die große Zahl ist das Dringliche, das Abzeichen kündigt an, was bald fällig wird. Ein Klick auf eine Kachel klappt die Liste dazu auf.',
				},
				activity: {
					title: 'Aktivitäten',
					text: 'Zeigt, was sich zuletzt an Objekten, Personen, Dokumenten und Vorgängen geändert hat, auch durch den Abgleich mit dem ERP. Ein Klick öffnet die Details der Änderung.',
				},
				syncs: {
					title: 'Synchronisierung',
					text: 'Die letzten Abgleiche mit Ihrem ERP-System: wann sie liefen, ob sie abgeschlossen sind und wie viele Änderungen sie gebracht haben.',
				},
				review_documents: {
					title: 'Belegprüfung',
					text: 'Belegprüfungen mit Fortschritt, offenen Prüfern und Frist. Ein Klick öffnet die Prüfung.',
				},
			},
			user: {
				welcome: {
					title: 'Ihr Dashboard',
					text: 'Auf dem Dashboard sehen Sie auf einen Blick, was es Neues gibt und was für Sie ansteht. In wenigen Schritten zeigen wir Ihnen, wie Sie es lesen und nach Ihren Wünschen anordnen. Beenden können Sie die Tour jederzeit über das ✕ oder <kbd>Esc</kbd>.',
				},
				kpi: {
					title: 'Kennzahlen',
					text: 'Die Leiste zeigt, wie viele Ihrer Vorgänge offen sind, zum Beispiel Meldungen. Ein Klick auf eine Kachel klappt die Liste dazu auf.',
				},
				notes: {
					title: 'Notizen',
					text: 'Aktuelle Mitteilungen Ihrer Verwaltung zu Ihren Objekten. Über die Filter im Widget wählen Sie Objekt oder Art der Notiz.',
				},
				documents: {
					title: 'Neue Dokumente',
					text: 'Dokumente, die seit Ihrer letzten Anmeldung neu hinzugekommen sind oder aktualisiert wurden.',
				},
				review_documents: {
					title: 'Belegprüfung',
					text: 'Die Belegprüfungen, an denen Sie beteiligt sind, mit Fortschritt und Frist. Ein Klick öffnet die Prüfung.',
				},
			},
		},
	},
}
